// extracted by mini-css-extract-plugin
export default {"campaignManager":"Campaign_campaignManager__0nPNT","campaignContainer":"Campaign_campaignContainer__GY14l"};